/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SysqueCheckboxOptionsLineComponent } from './sysque-check-box-options-line.component';
import { DxCheckBoxModule } from 'devextreme-angular';

@NgModule({
  declarations: [SysqueCheckboxOptionsLineComponent],
  imports: [CommonModule, DxCheckBoxModule],
  exports: [SysqueCheckboxOptionsLineComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SysqueCheckBoxOptionsLineModule {}
